module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Normal.7f3ffd4a.ttf";